import React,{ useState, useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';

export const NextHorse = (props) => {
  const [data, setdata] = useState([]);
  const [loaded, setloaded] = useState(false);

  useEffect(() => {
    if(props.data.length !== 0) {
      setdata(props.data);
      setloaded(true);
    }
  }, [props]);

  function info() {
    if(data.current.hipnr) {
      return(
        <div>
          <h2>#{data.current.hipnr} {data.current.horsename}</h2>
        </div>
      )
    }
    return(<></>);
  }

  let content = loaded
    ? info()
    : <Spinner/>;

    return(
      <>
        {content}
      </>
    );
}